/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.security.pd-administrators'},
});

const PdAdministratorsItem = () => (
  <RouteLinkItem
    route="midas/settings/security/pd-administrators"
    title={messages.title}
  />
);

export default PdAdministratorsItem;
